var YouLiS3ResourceUpload = function (options, queueElement) {

    this.queueElement = queueElement;

    this.resourceDisplayName = "";
    this.contentType = "";
    this.uploadAttemptsCount = 0;

    this.options = $.extend({
        UploadUrl: "",
        SuccessURL: "",
        KeyPrefix: "",
        ACL: "",
        Uuid: "",
        AccessKey: "",
        Policy: "",
        PolicySignature: "",
        NewFileKey: "",
        FileTypeDescription: "image",
        FileTypeErrorText: "",
        MaxFileSize: 8000000,
        ValidFileTypes: ["image/gif", "image/jpeg", "image/png", "application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/plain", "application/vnd.apple.numbers", "application/vnd.apple.pages"],
    }, options);

    this.progressHandler = function (e) {
        var self = this;
        if (e.lengthComputable) {
            var percentComplete = Math.round(e.loaded * 100 / e.total);
            self.queueElement.find(".file-progress").css("width", percentComplete + '%').attr('aria-valuenow', percentComplete);
            self.queueElement.find('.file-progress span').text(percentComplete + "%");
        }
        else {
            self.queueElement.find('.file-progress span').text('unable to compute');
        }
    };

    this.completeHandler = function (xhr, status) {
        self.queueElement.find(".progress").addClass("hidden");
    };

    this.successHandler = function (result, status, xhr) {
        if (xhr && xhr.status == 200) {
            alert("Success");
        }
    };

    this.errorHandler = function (xhr, status, error) {
        alert("There was an error attempting to upload the file. (" + error + ")");
    };
};

YouLiS3ResourceUpload.prototype.SingleFileSelected = function (selectedFile, overrideSuccessHandler, overrideErrorHandler, overrideCompleteHandler, overrideProgressHandler) {

    if (selectedFile) {
        if (selectedFile.size > this.options.MaxFileSize) {
            alert("File must be max " + (this.options.MaxFileSize / 1000000) + "MB in size");
            return false;
        }
        else if (this.options.ValidFileTypes.length > 0 && !(YouLi.Validation.IsValidFileType(selectedFile, this.options.ValidFileTypes))) {
            // the file doesn't match the valid file types or any of the override extensions
            if (this.options.FileTypeErrorText.length > 0) {
                alert(this.options.FileTypeErrorText);
            }
            else {
                alert("File must be a valid " + this.options.FileTypeDescription);
            }
            return false;
        }

        this.UploadFile(selectedFile, overrideSuccessHandler, overrideErrorHandler, overrideCompleteHandler, overrideProgressHandler);
    }

    return true;
};

YouLiS3ResourceUpload.prototype.UploadFile = function (selectedFile, overrideSuccessHandler, overrideErrorHandler, overrideCompleteHandler, overrideProgressHandler) {

    var self = this;

    var redirect = "";

    if (typeof FormData === "undefined") {
        // Redirect to an empty page is required for IE < 10
        redirect = this.options.SuccessURL;
    }

    var dataString = new FormData();

    this.options.NewFileKey = this.options.KeyPrefix + selectedFile.name;
    this.resourceDisplayName = selectedFile.name;
    this.contentType = YouLi.Common.Utils.MimeType(YouLi.Common.Utils.GetFileExtension(selectedFile.name));

    dataString.append("key", this.options.NewFileKey);
    dataString.append("acl", this.options.ACL);
    dataString.append("Content-Type", YouLi.Common.Utils.MimeType(YouLi.Common.Utils.GetFileExtension(selectedFile.name)));
    dataString.append("x-amz-meta-uuid", this.options.Uuid);
    dataString.append("AWSAccessKeyId", this.options.AccessKey);
    dataString.append("Policy", this.options.Policy);
    dataString.append("Signature", this.options.PolicySignature);
    dataString.append("success_action_redirect", redirect);
    dataString.append('file', selectedFile);

    if (self.queueElement !== undefined) {
        self.queueElement.find(".file-progress").css("width", '0%').attr('aria-valuenow', 0);
        self.queueElement.find(".progress").removeClass("hidden");
    };

    $.ajax({
        url: this.options.UploadUrl,
        type: 'POST',
        xhr: function () {  // Custom XMLHttpRequest
            var myXhr = $.ajaxSettings.xhr();
            if (myXhr.upload) { // Check if upload property exists
                myXhr.upload.addEventListener('progress', (function (passedInElement) {
                    return function (e) { overrideProgressHandler !== undefined ? overrideProgressHandler(e, passedInElement) : self.progressHandler(e, passedInElement); };
                })(self.queueElement), false); // For handling the progress of the upload
            }
            return myXhr;
        },
        //Ajax events
        success: function (result, status, xhr) {
            if (overrideSuccessHandler !== undefined) {
                eval(overrideSuccessHandler(result, status, xhr, self.queueElement, self.options.NewFileKey, self.resourceDisplayName, self.contentType));
            }
            else {
                self.successHandler(result, status, xhr);
            }
        },
        error: function (xhr, status, error) {
            if (overrideErrorHandler !== undefined) {
                eval(overrideErrorHandler(xhr, status, error, self));
            }
            else {
                self.errorHandler(xhr, status, error);
            }
        },
        complete: function (xhr, status) {
            if (overrideCompleteHandler !== undefined) {
                eval(overrideCompleteHandler(xhr, status, self.queueElement));
            }
            else {
                self.completeHandler(xhr, status);
            }
        },
        // Form data
        data: dataString,
        //Options to tell jQuery not to process data or worry about content-type.
        cache: false,
        contentType: false,
        processData: false
    });
};